export default "__VITE_ASSET__dY75S0fc__"